module.exports = __webpack_public_path__ + "media/images/about/time/3-a0bf95f1f4389af69b8760be4fc11509.png";